import React from 'react';
import { MenuCategoryPropType, MenuItemPropType } from '../../../services/proptypes';
import { getCategoryItems } from '../utils';
var SpecialCategory = function SpecialCategory(_ref) {
  var children = _ref.children,
    specials = _ref.specials;
  return getCategoryItems(specials).map(function (_ref2) {
    var name = _ref2.name,
      items = _ref2.items;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: name
    }, /*#__PURE__*/React.createElement("h3", {
      className: "special-category"
    }, name), children(items));
  });
};
export default SpecialCategory;